<template>
    <div class="login" v-show="type == 'browser'">
        <div class="logo">
            <img src="../assets/images/logo/logo_blue.png" alt="">
        </div>

        <div class="login_area" v-if="$store.state.type == 'pc'">
            <div class="login_pic">
                <img src="../assets/images/login/login_box.png" alt="">
            </div>
            <div class="line"></div>
            <div class="login_box">
                <div class="title">集海运营平台</div>
                <div class="des">扫码登录</div>
                <div class="tip">请使用飞书移动端扫描二维码</div>
                <div id="login_qrcode"></div>
            </div>
        </div>
        <div class="mobile_msg" v-else>
            <span>请使用飞书工作台打开应用</span>
        </div>
    </div>
</template>
<script>
export default({
    name: 'login',
    data() {
        return {
            type: 'fs',   //打开页面方式
            QRLoginObj: '',
            goto: '',
            redirect_url: window.location.origin + '/',
            fromRoute: ''
        }
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            //页面未登录或登录失效，返回登录页，保存之前页面信息，登录后跳转回去
            if(from.name && from.name != 'login' && from.name != 'error') {
                vm.fromRoute = from;
            }
        });
    },
    mounted() {
        if(this.fromRoute) {
            localStorage.setItem('fromRoute', JSON.stringify(this.fromRoute));
        }
        if(localStorage.getItem('token') && localStorage.getItem('loginTime')) {  //存在用户登录态
            if(new Date().getTime() - parseInt(localStorage.getItem('loginTime')) < 3400 * 1000) { //token未过期
                if(localStorage.getItem('fromRoute')) {
                    let r = JSON.parse(localStorage.getItem('fromRoute'));
                    localStorage.removeItem('fromRoute');
                    this.$router.push({name: r.name, params: r.params, query: r.query});
                    return;
                }
                this.$router.push({name: 'home', query: {t: new Date().getTime()}});
                return;
            }
        }
        if(this.$route.query.code) {
            this.login(this.$route.query.code, true);
        }else if(window.h5sdk) { //飞书内打开页面，免登录
            this.type = 'fs';
            window.h5sdk.ready(() => {
                this.fsApi('requestAuthCode', {appId: process.env.APP_ID}).then(data => {
                    this.login(data.code, false);
                })
            })
        }else{ //浏览器打开页面，飞书扫码登录
            this.type = 'browser';
            //生成飞书登录二维码，嵌入id为login_qrcode的元素内，不能放在created里
            const redirect_url = encodeURIComponent(this.redirect_url);
            // window.location.href = `https://open.feishu.cn/open-apis/authen/v1/authorize?app_id=${process.env.APP_ID}&redirect_uri=${redirect_url}`
            this.goto = `https://passport.feishu.cn/suite/passport/oauth/authorize?client_id=${process.env.APP_ID}&redirect_uri=${redirect_url}&response_type=code&state=`;
            this.QRLoginObj = window.QRLogin({  
                id: "login_qrcode",
                goto: this.goto,
                width: "260",
                height: "260",
            });
            window.addEventListener('message', this.handleMessage, false);
        }
    },
    methods: {
        login(code, is_web) {
            this.api.login({code: code, is_web: is_web, redirect_url: this.redirect_url}).then(data => {
                localStorage.setItem('token', data.data.access_token);
                this.$store.commit('setToken', data.data.access_token);
                localStorage.setItem('expires', data.data.expiresIn);
                setTimeout(() => {
                    this.getUserInfo();
                }, 0)
                
            })
        },
        getUserInfo() {
            this.api.getUserInfo({}).then(data => {
                localStorage.setItem('userInfo', JSON.stringify(data.data));
                this.$store.commit('updateUserInfo', data.data);
                localStorage.setItem('loginTime', new Date().getTime());
                if(localStorage.getItem('fromRoute')) {
                    let r = JSON.parse(localStorage.getItem('fromRoute'));
                    localStorage.removeItem('fromRoute');
                    this.$router.push({name: r.name, params: r.params, query: r.query});
                    return;
                }
                this.$router.push({name: 'home', query: {t: new Date().getTime()}});
            })
        },
        handleMessage(event) {
            var origin = event.origin; 
            // 使用 matchOrigin 方法来判断 message 是否来自飞书页面
            if( this.QRLoginObj .matchOrigin(origin) ) {           
                var loginTmpCode = event.data.tmp_code; 
                // 在授权页面地址上拼接上参数 tmp_code，并跳转
                window.location.href = `${this.goto}&tmp_code=${loginTmpCode}`;
            }
        }
    },
    beforeDestroy() {
        window.removeEventListener('message', this.handleMessage);
    }
})
</script>
<style lang="less" scoped>
    .login{
        height: 100%;
        position: relative;
        background: url('../assets/images/login/bg.png') no-repeat;
        background-size: cover;
        .logo{
            width: 148px;
            position: absolute;
            top: 40px;
            left: 40px;
        }
    }
    .login_area{
        width: 900px;
        height: 500px;
        background-color: rgb(255,255,255);
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border-radius: 16px;
        .transformLayout();
        .flexLayout();
        flex-wrap: nowrap;
        .login_pic{
            width: 54%;
            height: 100%;
            .flexLayout(flex-start);
            img{
                width: 95%;
            }
        }
        .line{
            width: 1px;
            height: 100%;
            background: linear-gradient(180deg, rgba(255,255,255,.1) 0%, rgba(0,0,0,.1), rgba(255,255,255,.1) 100%);
        }
        .login_box{
            flex: 1;
            background-color: rgb(255,255,255);
            text-align: center;
            border-radius: 12px;
            
            .title{
                font-size: 24px;
                font-weight: 600;
                color: @colorBlue2;
            }
            .des{
                font-size: 20px;
                font-weight: 600;
                margin: 20px 0;
            }
            .tip{
                font-size: 15px;
                color: #999;
            }
            #login_qrcode{
                width: 260px;
                height: 260px;
                margin: 0 auto;
                transform: scale(.8);
                /deep/ iframe{
                    border: none!important;
                    overflow: hidden;
                }
            }
        }
    }
    .mobile_msg{
        width: 92%;
        line-height: 100px;
        padding: 0 4%;
        background: @colorWhite;
        text-align: center;
        font-size: 20px;
        font-weight: 600;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translate(0, -50%);
    }
</style>



// WEBPACK FOOTER //
// src/view/login.vue